import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getGimsSection,
  getSectionsBySearchParams,
} from "../../../../redux/directoryMaintenance/gimsSectionsReducer/actionsGimsSections";

import GimsSectionsModal from "./gimsSectionsModal/gimsSectionsModal";
import GeneralSectionComponent from "../generalSectionComponent";
import SearchBlockRHF from "../../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";

import { GIMS_SECTIONS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";
import { CLEAR_GIMS_SECTION, SET_SEARCH_PARAMS_GIMS_SECTIONS } from "../../../../redux/types";

import {
  options,
  setOptionsDepartments,
  setOptionsSections,
} from "../../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./gimsSections.module.css";

function GimsSections() {
  const dispatch = useDispatch();
  const [innerOptions, setInnerOptions] = useState({});
  const [searchParams, setSearchParams] = useState({
    sctId: 0,
    depId: 0,
  });

  const dictionaryReducer = useSelector((state) => state.dictionaryReducer);

  const gimsSectionsReducer = useSelector((state) => state.gimsSectionsReducer);
  const handleChange = async (e) => {
    if (e.value) {
      setSearchParams({
        ...searchParams,
        [e.key]: e.value,
      });
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch({
      type: SET_SEARCH_PARAMS_GIMS_SECTIONS,
      data: searchParams,
    });
    dispatch(getSectionsBySearchParams(searchParams));
  };

  const handleClear = () => {
    dispatch({
      type: SET_SEARCH_PARAMS_GIMS_SECTIONS,
      data: { sctId: 0, depId: 0 },
    });
    dispatch({
      type: CLEAR_GIMS_SECTION,
    });
    dispatch(getSectionsBySearchParams({ sctId: 0, depId: 0 }));
    setSearchParams({ sctId: 0, depId: 0 });
  };

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections.map((item) => {
          return { ...item, key: "sctId" };
        }),
        options.inputsSections.key,
      );
    }
    if (dictionaryReducer.departmentAll.length > 0) {
      setOptionsDepartments(
        dictionaryReducer.departmentAll.map((item) => {
          return { ...item, key: "depId", value: item.depId };
        }),
        options.inputsSections.key,
      );
    }
    dispatch(getSectionsBySearchParams(searchParams));
  }, []);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(
        dictionaryReducer.gimsSections.map((item) => {
          return { ...item, key: "sctId" };
        }),
        options.inputsSections.key,
      );
    }
    if (dictionaryReducer.departmentAll.length > 0) {
      setOptionsDepartments(
        dictionaryReducer.departmentAll.map((item) => {
          return { ...item, key: "depId", value: item.depId };
        }),
        options.inputsSections.key,
      );
    }
  }, [dictionaryReducer]);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsSections}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <GeneralSectionComponent
        title={
          gimsSectionsReducer.sections.length > 0
            ? `Результаты поиска: ${gimsSectionsReducer.sections.length}`
            : ""
        }
        dataFromStateSelector={(state) => state.gimsSectionsReducer.sections || []}
        getAction={getGimsSection}
        headerColumns={GIMS_SECTIONS_COLUMNS}
        ModalComponent={GimsSectionsModal}
        searchTableSize={15}
      />
    </div>
  );
}

export default GimsSections;
